<template>
  <div>
    <div class="group_store_alert alert">
      <div class="group_store_box alert_box">
        <h3>로그아웃 하시겠습니까?</h3>
        <div class="group_store_btn">
          <p @click="$emit('closeLogoutModal')">아니오</p>
          <p id="color_txt" @click="checkLogout">네</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/service/axios';
import { cookies } from '@/utils/cookies';

export default {
  name: 'logout',
  methods: {
    async checkLogout() {
      const accessToken = cookies.get('aToken');
      const refreshToken = cookies.get('rToken');

      try {
        await axios.post('/api/auth/logout', { accessToken, refreshToken });
      } catch (error) {
        console.error('[logout error]', error);
      } finally {
        this.$store.dispatch('logout');
      }
    },
  },
};
</script>
